const MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
]
const DAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]

function pad(num){
    return num < 10 ? '0' + num : num.toString()
}

function parseMonth(str){
    for (let i = 0, j = MONTHS[0]; j; j = MONTHS[++i]){
        if (str === j){
            return i
        }
    }
    throw new Error(`Bad month string ${str}`)
}

function parse(date){
    let parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(:?\.\d+)?(Z?)$/.exec(date)
    if (parts){
        return parts[8] ? new Date(Date.UTC(
            parseInt(parts[1]),
            parseInt(parts[2]) - 1,
            parseInt(parts[3]),
            parseInt(parts[4]),
            parseInt(parts[5]),
            parseInt(parts[6])
        )) : new Date(
            parseInt(parts[1]),
            parseInt(parts[2]) - 1,
            parseInt(parts[3]),
            parseInt(parts[4]),
            parseInt(parts[5]),
            parseInt(parts[6])
        )
    }
    parts = /^(\d+) (\w+)(?:\s(\d{4}))?/.exec(date)
    if (parts){
        let year = parts[3]
        year = year ? parseInt(year) : (new Date()).getFullYear()
        return new Date(
            year,
            parseMonth(parts[2]),
            parseInt(parts[1])
        )
    }
    return new Date()
}

export class DateFormat{
    constructor(date) {
        if (date){
            this.raw = date instanceof Date ? date : parse(date)
        }
    }

    isSameDay(other){
        return this.raw.getFullYear() === other.raw.getFullYear() &&
            this.raw.getMonth() === other.raw.getMonth() &&
            this.raw.getDate() === other.raw.getDate()
    }

    dayMonth(){
        return `${this.raw.getDate()} ${MONTHS[this.raw.getMonth()]}`
    }

    date(){
        if (!this.raw){
            return ''
        }
        const today = new Date()
        if (today.getFullYear() === this.raw.getFullYear()){
            if (today.getMonth() === this.raw.getMonth() && today.getDate() === this.raw.getDate()){
                return 'today'
            }
            return this.dayMonth()
        }
        return `${this.dayMonth()} ${this.raw.getFullYear()}`
    }

    day(){
        return DAYS[this.raw.getDay()];
    }

    time(){
        if (!this.raw){
            return ''
        }
        let hours = this.raw.getHours()
        const amPm = hours > 11 ? 'pm' : 'am'
        hours %= 12
        if (hours === 0){
            hours = 12
        }
        return `${hours}:${pad(this.raw.getMinutes())} ${amPm}`
    }

    datetime(){
        if (!this.raw){
            return ''
        }
        return `${this.time()}, ${this.date()}`
    }
}
